module.exports = __webpack_public_path__ + "img/brand-logo-white.e6ec55c2.png";